import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import styles from './Ibtikar.module.css';
import axios from 'axios';
import {API} from '../../../config/API';
import Loader from '../../../components/Loader/Loader';
import { Util } from '../../../config/Util';
import toast from 'react-hot-toast';


const Submissions = () => {
    const [data, setData] = useState([]);
    const [fullData, setFullData] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [form, setForm] = useState({
        submitterEmail: '',
        submitterPhone: '',
        submitterEmpId: '',
        createdDate: '',
        submitType: 'individual',
        ideaProblem: '',
        rootCause: '',
        solutionProposed: '',
        benefits: '',
        beforeImage: null,
        afterImage: null,
    });

    const [modalOpen, setModalOpen] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [loader, setLoader] = useState(false);
    const [users, setUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [userSearchTerm, setUserSearchTerm] = useState('');
    const [showUserDropdown, setShowUserDropdown] = useState(false);

    const columns = [
        { name: 'ID', selector: row => row.id, sortable: true, center: true, grow: 0.5 },
        {
            name: 'TITLE',
            selector: row => row.ideaProblem,
            sortable: true,
            center: true,
            grow: 5,
            cell: row => (
                <span className={styles.tableEllipsis} title={row.ideaProblem}>
                    {row.ideaProblem}
                </span>
            ),
            minWidth: '120px',
            maxWidth: '280px',
        },
        { name: 'SUBMITTED', selector: row => row.submitted, center: true, grow: 2 },
        { name: 'STATUS', selector: row => (row && row.status ? String(row.status).toUpperCase() : ''), center: true, grow: 2 },
        {
            name: 'ACTIONS',
            cell: row => (
                <button
                    className='btn btn-info'
                    onClick={() => { setModalData(row); setModalOpen(true); }}
                >
                    VIEW
                </button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const getStatusClass = (status) => {
        if (!status) return '';
        const s = String(status).toLowerCase();
        // Map domain statuses to existing badge styles
        if (s.includes('completed')) return styles.statusApproved; // completed -> green
        if (s.includes('rejected')) return styles.statusRejected;  // rejected -> red
        if (s.includes('open')) return styles.statusOpen;
        if (s.includes('implementation')) return styles.statusImplementation;
        if (s.includes('review')) return styles.statusReview;

        return '';
    };

    useEffect(() => {
        fetchIdeas();
        fetchUsers();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const dropdownElement = document.getElementById('userDropdownContainer');
            if (dropdownElement && !dropdownElement.contains(event.target)) {
                setShowUserDropdown(false);
            }
        };

        if (showUserDropdown) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showUserDropdown]);

    //Function to fetch users from API
    const fetchUsers = async () => {
        try {
            const resp = await axios.get(API.listUser);
            if (resp && resp.status === 200 && resp.data) {
                // Exclude super admin users
                const filteredUsers = resp.data.users.filter(user => user.role !== 'SUPER_ADMIN');
                setUsers(filteredUsers);
            }
        } catch (er) {
            console.log("Error fetching users:", er);
        }
    };

    //Function to fetch ideas submitted by the user from API
    const fetchIdeas = async () => {
        //API call logic goes here
        const auth = Util.getFromSession("auth");
        const userId = auth && auth.id ? auth.id : undefined;
        try{
            setLoader(true);
              const data = await axios.get(API.myIdeas, { params: { userId } });
            //Process and set data
            if(data && data.data && data.data.status === 'S' && Array.isArray(data.data.ideas)){
                // filter ideas submitted by the current user only (empUserId === userId)
                const ideas = data.data.ideas || [];
                const myIdeas = ideas.filter(idea => Number(idea.empUserId) === Number(userId));
                setData(myIdeas);
                setFullData(myIdeas);
            }
        }catch(err){
            console.log("error while fetching ideas.");  
        }finally{
            setLoader(false);
        }
      
    };

    const filterData = (e) => {
        const key = e.target.value || '';
        if (!key) return setData(fullData);
        const filtered = fullData.filter(item => item.name.toLowerCase().includes(key.toLowerCase()));
        setData(filtered);
    };

    const handleChange = (e) => {
        const { name, value, files, type } = e.target;
        if (type === 'file') return setForm(prev => ({ ...prev, [name]: files && files[0] ? files[0] : null }));
        if (name === 'submitType' && value === 'individual') {
            // Clear selected users when switching to individual
            setSelectedUsers([]);
        }
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleUserSearch = (e) => {
        setUserSearchTerm(e.target.value);
    };

    const toggleUserSelection = (user) => {
        const isSelected = selectedUsers.find(u => u.id === user.id);
        if (isSelected) {
            setSelectedUsers(selectedUsers.filter(u => u.id !== user.id));
        } else {
            setSelectedUsers([...selectedUsers, user]);
        }
    };

    const removeSelectedUser = (userId) => {
        setSelectedUsers(selectedUsers.filter(u => u.id !== userId));
    };

    const getFilteredUsers = () => {
        if (!userSearchTerm) return users;
        const searchLower = userSearchTerm.toLowerCase();
        return users.filter(user => 
            (user.username && user.username.toLowerCase().includes(searchLower)) ||
            (user.name && user.name.toLowerCase().includes(searchLower)) ||
            (user.email && user.email.toLowerCase().includes(searchLower))
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Client-side validation
        if (!form.ideaProblem.trim()) {
            toast.error('Please enter the Idea/Problem');
            return;
        }
        if (!form.rootCause.trim()) {
            toast.error('Please enter the Root Cause');
            return;
        }
        if (!form.solutionProposed.trim()) {
            toast.error('Please enter the Solution Proposed');
            return;
        }
        if (!form.benefits.trim()) {
            toast.error('Please enter the Benefits');
            return;
        }
        if (form.submitType === 'group' && selectedUsers.length === 0) {
            toast.error('Please select at least one team member for group submission');
            return;
        }
        // if (!beforeImage && !afterImage) {
        //     toast.error('Please upload image (Before and After)');
        //     return;
        // }
        
        setLoader(true);
        const req = { ...form };
        req.createdDate = new Date().toISOString().slice(0,10);
        const userId = Util.getFromSession("auth").id;
        req.submitterUserId = userId;
        //req.submitterEmpId = "100";
        
        // Add members array if submitType is group
        if (form.submitType === 'group') {
            req.members = selectedUsers.map(user => user.username || user.name);
        }

        const { beforeImage, afterImage, ...jsonPayload } = req;

        const formData = new FormData();
        // Append JSON as a Blob so backend can parse it as a part named 'data'
        //formData.append('data', JSON.stringify(jsonPayload));
        console.log("jsonPayload", jsonPayload);
        formData.append(
        'data',
        new Blob([JSON.stringify(jsonPayload)], { type: 'application/json' })
      );
        if (beforeImage) formData.append('beforeImage', beforeImage);
        if (afterImage) formData.append('afterImage', afterImage);
        
        try {
            const data = await axios.post(API.submitIdea, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (data && data.data && data.data.status === 'S') {
                //show acknowledgement
                toast.success('Idea Submitted Successfully');
                handleCancel();
                await fetchIdeas();
                
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoader(false);
        }
    };

    const handleCancel = () => {
        setForm({
            empId: '',
            idea_date: new Date().toISOString().slice(0,10),
            submitType: 'individual',
            ideaProblem: '',
            rootCause: '',
            solutionProposed: '',
            benefits: '',
            beforeImage: null,
            afterImage: null,
            status: 'open'
        });
        setSelectedUsers([]);
        setUserSearchTerm('');
        setShowUserDropdown(false);
        setShowForm(false);
    };

    const handleResubmit = async () => {
        if (!modalData || !modalData.id) return;
        
        try {
            setLoader(true);
            const req = { id: modalData.id, status: 'open' };
            const response = await axios.post(API.updateIdeaStatus, req);
            
            if (response && (response.status === 200 || response.status === 201) && response.data && response.data.status === 'S') {
                toast.success('Idea resubmitted successfully');
                setModalOpen(false);
                setModalData(null);
                await fetchIdeas();
            } else {
                toast.error('Failed to resubmit idea');
            }
        } catch (error) {
            console.log('Error resubmitting idea:', error);
            toast.error('Error resubmitting idea');
        } finally {
            setLoader(false);
        }
    };

    return (
        <>
        <Loader loading={loader}></Loader>
        <div className={styles.container || ''} data-testid="ibtikar-submissions">
            <div className='bread-crumb overflow-auto'>
                <div>
                    <span className='breadcrumb-title'>
                        <input type='button' className='btn' value='Home - Submissions'></input>
                    </span>
                     <span className='fr'>
                        <input type='button' className='btn btn-success' value='SUBMIT IDEA' onClick={() => setShowForm(true)}></input>
                     </span>
                </div>
            </div>

            <div className='data-table-holder'>
                {showForm ? (
                    <div className='submission-form card p-5'>
                        {/* <h4>IBTIKAR CI Idea Submission Form</h4> */}
                        <form onSubmit={handleSubmit}>
                            <div className='row'>
                                <div className='col-md-6 mb-3'>
                                    <label>Email Address:</label>
                                    <input name='submitterEmail' value={form.submitterEmail} onChange={handleChange} type='email' className='form-control' placeholder='Email Address' />
                                </div>
                                <div className='col-md-6 mb-3'>
                                    <label>Mobile Number:</label>
                                    <input name='submitterPhone' value={form.submitterPhone} onChange={handleChange} className='form-control' placeholder='Mobile Number' />
                                </div>
                            </div>

                            <div className='form-group'>
                                <div className='d-flex align-items-center'>
                                    <div className='mr-3 font-weight-bold'>Are you Submitting IBTIKAR as an Individual or as a Team :</div>
                                    <div className='inline-radios ml-3'>
                                        <label><input type='radio' name='submitType' value='individual' checked={form.submitType === 'individual'} onChange={handleChange} />&nbsp;As Individual</label>
                                        <label><input type='radio' name='submitType' value='group' checked={form.submitType === 'group'} onChange={handleChange} />&nbsp;As Group</label>
                                    </div>
                                </div>
                            </div>

                            {form.submitType === 'group' && (
                                <div className='form-group'>
                                    <label className='font-weight-bold'>Select Team Members:</label>
                                    <div id='userDropdownContainer' style={{ position: 'relative' }}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: '8px',
                                                padding: '10px 12px',
                                                border: 'none',
                                                borderRadius: '8px',
                                                minHeight: '46px',
                                                alignItems: 'center',
                                                cursor: 'text',
                                                backgroundColor: '#f3f4f6',
                                                transition: 'box-shadow 0.2s ease, background-color 0.2s ease'
                                            }}
                                            onClick={() => document.getElementById('userSearchInput').focus()}
                                        >
                                            {selectedUsers.map(user => (
                                                <div
                                                    key={user.id}
                                                    style={{
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        padding: '5px 12px',
                                                        background: 'linear-gradient(135deg, rgba(241, 92, 42, 0.12) 0%, rgba(241, 92, 42, 0.06) 100%)',
                                                        border: 'none',
                                                        borderRadius: '20px',
                                                        fontSize: '13px',
                                                        gap: '6px',
                                                        color: '#c44419',
                                                        fontWeight: '500'
                                                    }}
                                                >
                                                    <span>{user.username || user.name}</span>
                                                    <button
                                                        type='button'
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            removeSelectedUser(user.id);
                                                        }}
                                                        style={{
                                                            background: 'none',
                                                            border: 'none',
                                                            color: '#F15c2a',
                                                            cursor: 'pointer',
                                                            fontSize: '18px',
                                                            padding: 0,
                                                            lineHeight: 1,
                                                            fontWeight: '600',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            width: '18px',
                                                            height: '18px',
                                                            borderRadius: '50%',
                                                            transition: 'background 0.15s ease'
                                                        }}
                                                        onMouseEnter={(e) => e.target.style.background = 'rgba(241, 92, 42, 0.1)'}
                                                        onMouseLeave={(e) => e.target.style.background = 'none'}
                                                    >
                                                        ×
                                                    </button>
                                                </div>
                                            ))}
                                            <input
                                                id='userSearchInput'
                                                type='text'
                                                style={{
                                                    border: 'none',
                                                    outline: 'none',
                                                    flex: 1,
                                                    minWidth: '120px',
                                                    padding: '4px',
                                                    fontSize: '0.95rem',
                                                    color: '#374151'
                                                }}
                                                placeholder={selectedUsers.length === 0 ? 'Search and select team members...' : ''}
                                                value={userSearchTerm}
                                                onChange={handleUserSearch}
                                                onFocus={() => setShowUserDropdown(true)}
                                            />
                                        </div>
                                        {showUserDropdown && (
                                            <div style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                right: 0,
                                                maxHeight: '220px',
                                                overflowY: 'auto',
                                                backgroundColor: 'white',
                                                border: '1px solid #e5e7eb',
                                                borderRadius: '10px',
                                                zIndex: 1000,
                                                marginTop: '4px',
                                                boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.05)'
                                            }}>
                                                {getFilteredUsers().length > 0 ? (
                                                    getFilteredUsers().map(user => {
                                                        const isSelected = selectedUsers.find(u => u.id === user.id);
                                                        return (
                                                            <div
                                                                key={user.id}
                                                                onClick={() => toggleUserSelection(user)}
                                                                style={{
                                                                    padding: '10px 14px',
                                                                    cursor: 'pointer',
                                                                    backgroundColor: isSelected ? 'rgba(241, 92, 42, 0.06)' : 'white',
                                                                    borderBottom: '1px solid #f3f4f6',
                                                                    transition: 'background-color 0.15s ease'
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    if (!isSelected) e.currentTarget.style.backgroundColor = '#f9fafb';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    if (!isSelected) e.currentTarget.style.backgroundColor = 'white';
                                                                }}
                                                            >
                                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                    <div>
                                                                        <div style={{ fontWeight: '500', color: '#1f2937', fontSize: '0.9rem' }}>{user.username || user.name}</div>
                                                                        {(user.name) && <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>{user.name}</div>}
                                                                    </div>
                                                                    {isSelected && <span style={{ color: '#F15c2a', fontWeight: 'bold', fontSize: '1.1rem' }}>✓</span>}
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                ) : (
                                                    <div style={{ padding: '16px', textAlign: 'center', color: '#9ca3af', fontSize: '0.9rem' }}>
                                                        No users found
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            <div className='form-group'>
                                <label>IBTIKAR Idea or Problem You Want to Solve (Max 1000 Characters)</label>
                                <textarea name='ideaProblem' value={form.ideaProblem} onChange={handleChange} className='form-control' maxLength={1000} rows={3} />
                            </div>

                            <div className='form-group'>
                                <label>Root Cause (Max 500 Characters)</label>
                                <textarea name='rootCause' value={form.rootCause} onChange={handleChange} className='form-control' maxLength={500} rows={3} />
                            </div>

                            <div className='form-group'>
                                <label>Solution Proposed (Max 1000 Characters)</label>
                                <textarea name='solutionProposed' value={form.solutionProposed} onChange={handleChange} className='form-control' maxLength={1000} rows={3} />
                            </div>

                            <div className='form-group'>
                                <label>Benefits Of Implementing This IBTIKAR Idea</label>
                                <textarea name='benefits' value={form.benefits} onChange={handleChange} className='form-control' rows={3} />
                            </div>

                            <div className='form-group'>
                                <label>Upload Images</label>
                                <div className='row'>
                                    <div className='col-md-6 mb-3'>
                                        <label className='small font-weight-bold'>Before Implementation</label>
                                        <input name='beforeImage' onChange={handleChange} type='file' accept='image/*' className='form-control-file' />
                                    </div>
                                    {/* After Image section hidden as per requirement */}
                                    {/* <div className='col-md-6 mb-3'>
                                        <label className='small font-weight-bold'>After Implementation</label>
                                        <input name='afterImage' onChange={handleChange} type='file' accept='image/*' className='form-control-file' />
                                    </div> */}
                                </div>
                            </div>

                            <div className='mt-2'>
                                <button type='submit' className='btn btn-primary mr-2' onClick={handleSubmit}>SUBMIT IDEA</button>
                                <button type='button' className='btn btn-danger ml-2' onClick={handleCancel}>CANCEL</button>
                            </div>
                        </form>
                    </div>
                ) : (
                    <>
                        <div className='table-search-box'>
                            <input type='text' placeholder='Search Here..' className='form-control' onChange={filterData} />
                        </div>

                        <DataTable
                            subHeaderAlign='center'
                            columns={columns}
                            data={data}
                            pagination
                            striped
                        />
                        {modalOpen && modalData && (
                            <div className={styles.modalOverlay}>
                                <div className={`${styles.modalCard} card p-0`}>
                                    <div className={`d-flex justify-content-between align-items-center ${styles.modalHeader}`}>
                                        <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                                            <h5 className='m-0'>Submission Details</h5>
                                            <span className={`${styles.statusBadge} ${getStatusClass(modalData.status)}`}>{modalData.status || 'Unknown'}</span>
                                        </div>
                                        <button className={`btn btn-danger `} onClick={() => { setModalOpen(false); setModalData(null); }}>X</button>
                                    </div>
                                    <div className={styles.modalBody}>
                                        <div className={styles.modalSection}>
                                            <div className={styles.modalSectionTitle}>Submission Info</div>
                                            <div className='row'>
                                                <div className='col-sm-6'>
                                                    <div className={styles.modalField}><strong>ID:</strong> {modalData.id}</div>
                                                </div>
                                                <div className='col-sm-6'>
                                                    <div className={styles.modalField}><strong>Title:</strong> {modalData.name}</div>
                                                </div>
                                                <div className='col-sm-6'>
                                                    <div className={styles.modalField}><strong>Submitted:</strong> {modalData.submitted || (modalData.meta && modalData.meta.idea_date)}</div>
                                                </div>
                                                <div className='col-sm-6'>
                                                    <div className={styles.modalField}><strong>Submit Type:</strong> {modalData.submitType || (modalData.meta && modalData.meta.submitType)}</div>
                                                </div>
                                                <div className='col-sm-6'>
                                                    <div className={styles.modalField}><strong>Employee ID:</strong> {modalData.empId || (modalData.meta && modalData.meta.empId)}</div>
                                                </div>
                                                <div className='col-sm-6'>
                                                    <div className={styles.modalField}><strong>Email:</strong> {modalData.submitterEmail || (modalData.meta && modalData.meta.submitter && modalData.meta.submitter.email) || <span className={styles.modalTextMuted}>-</span>}</div>
                                                </div>
                                                <div className='col-sm-6'>
                                                    <div className={styles.modalField}><strong>Phone:</strong> {modalData.submitterPhone || (modalData.meta && modalData.meta.submitter && modalData.meta.submitter.phone) || <span className={styles.modalTextMuted}>-</span>}</div>
                                                </div>
                                                {(modalData.submitType === 'group' || (modalData.meta && modalData.meta.submitType === 'group')) && (modalData.members || (modalData.meta && modalData.meta.members)) && (
                                                    <div className='col-sm-12'>
                                                        <div className={styles.modalField}>
                                                            <strong>Group Members:</strong> 
                                                            <div style={{ marginTop: '6px', display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                                                                {(modalData.members || (modalData.meta && modalData.meta.members) || []).map((member, index) => (
                                                                    <span 
                                                                        key={index}
                                                                        style={{
                                                                            padding: '4px 10px',
                                                                            backgroundColor: '#e3f2fd',
                                                                            borderRadius: '12px',
                                                                            fontSize: '13px',
                                                                            color: '#1976d2'
                                                                        }}
                                                                    >
                                                                        {member}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className={styles.modalSection}>
                                            <div className={styles.modalSectionTitle}>Idea Details</div>
                                            <div className={styles.modalField}><strong>Idea / Problem:</strong><br />{modalData.ideaProblem || (modalData.meta && modalData.meta.ideaProblem) || <span className={styles.modalTextMuted}>-</span>}</div>
                                            <div className={styles.modalField}><strong>Root Cause:</strong><br />{modalData.rootCause || (modalData.meta && modalData.meta.rootCause) || <span className={styles.modalTextMuted}>-</span>}</div>
                                            <div className={styles.modalField}><strong>Solution Proposed:</strong><br />{modalData.solutionProposed || (modalData.meta && modalData.meta.solutionProposed) || <span className={styles.modalTextMuted}>-</span>}</div>
                                            <div className={styles.modalField}><strong>Benefits:</strong><br />{modalData.benefits || (modalData.meta && modalData.meta.benefits) || <span className={styles.modalTextMuted}>-</span>}</div>
                                            {modalData.rejectionComment && (
                                                <div className={styles.modalField}><strong>Rejection comment:</strong><br />{modalData.rejectionComment}</div>
                                            )}
                                            {modalData.implementorComment && (
                                                <div className={styles.modalField}><strong>Implementor Comment:</strong><br />{modalData.implementorComment}</div>
                                            )}

                                            <div className={styles.modalRow} style={{ marginTop: '0.5rem' }}>
                                                <div style={{ flex: '1 1 300px' }}>
                                                    <div className={styles.modalField}><strong>Before Image:</strong></div>
                                                    {modalData.beforeImage ? (
                                                        typeof modalData.beforeImage === 'string' ? <img className={styles.modalImage} src={modalData.beforeImage.startsWith('http') ? modalData.beforeImage : Util.baseURlForDownload + modalData.beforeImage} alt='before' /> : <div className='text-muted'>{modalData.beforeImage.name || 'Uploaded file'}</div>
                                                    ) : <div className='text-muted'>No image</div>}
                                                </div>
                                                
                                                 <div style={{ flex: '1 1 300px' }}>
                                                    <div className={styles.modalField}><strong>After Image:</strong></div>
                                                    {modalData.afterImage ? (
                                                        typeof modalData.afterImage === 'string' ? <img className={styles.modalImage} src={modalData.afterImage.startsWith('http') ? modalData.afterImage : Util.baseURlForDownload + modalData.afterImage} alt='after' /> : <div className='text-muted'>{modalData.afterImage.name || 'Uploaded file'}</div>
                                                    ) : <div className='text-muted'>No image</div>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {modalData && modalData.status && String(modalData.status).toLowerCase().includes('rejected') && (
                                        <div className={styles.modalFooter}>
                                            <button className='btn btn-secondary' onClick={() => { setModalOpen(false); setModalData(null); }}>Close</button>
                                            <button className='btn btn-primary' onClick={handleResubmit}>RE SUBMIT IDEA</button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
        </>
    );
};

export default Submissions;

